import { render, staticRenderFns } from "./ib-bar.vue?vue&type=template&id=630775a9&lang=pug&"
import script from "./ib-bar.vue?vue&type=script&lang=js&"
export * from "./ib-bar.vue?vue&type=script&lang=js&"
import style0 from "./ib-bar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630775a9')) {
      api.createRecord('630775a9', component.options)
    } else {
      api.reload('630775a9', component.options)
    }
    module.hot.accept("./ib-bar.vue?vue&type=template&id=630775a9&lang=pug&", function () {
      api.rerender('630775a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view/ib-bar.vue"
export default component.exports